import styled from 'styled-components/macro';

export const TooltipWrapper = styled('div')({
  color: 'black',
  border: '1px solid black',
  padding: '10px',
});
